import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "text-primary my-4" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_text_form = _resolveComponent("text-form");
    const _component_label_form = _resolveComponent("label-form");
    return (_ctx.preview)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.description), 1 /* TEXT */)
        ]))
        : (_openBlock(), _createBlock(_component_label_form, { key: 1 }, {
            default: _withCtx(() => [
                _createVNode(_component_text_form, {
                    modelValue: _ctx.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.value) = $event))
                }, null, 8 /* PROPS */, ["modelValue"])
            ]),
            _: 1 /* STABLE */
        }));
}
